// source: pbtypes/gen/flight_connect/video_fusion_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_flight_connect_transport_type_pb = require('../../../pbtypes/gen/flight_connect/transport_type_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_transport_type_pb);
var pbtypes_gen_flight_connect_video_stream_info_pb = require('../../../pbtypes/gen/flight_connect/video_stream_info_pb.js');
goog.object.extend(proto, pbtypes_gen_flight_connect_video_stream_info_pb);
goog.exportSymbol('proto.flight_connect.VideoFusionInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_connect.VideoFusionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.flight_connect.VideoFusionInfo.repeatedFields_, null);
};
goog.inherits(proto.flight_connect.VideoFusionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_connect.VideoFusionInfo.displayName = 'proto.flight_connect.VideoFusionInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.flight_connect.VideoFusionInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_connect.VideoFusionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_connect.VideoFusionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_connect.VideoFusionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.VideoFusionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
renderedFrameCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
outputChannel: jspb.Message.getFieldWithDefault(msg, 2, ""),
outputBitrate: jspb.Message.getFieldWithDefault(msg, 5, 0),
outputFramerate: jspb.Message.getFieldWithDefault(msg, 6, 0),
selectedTransport: jspb.Message.getFieldWithDefault(msg, 3, 0),
streamInfoList: jspb.Message.toObjectList(msg.getStreamInfoList(),
    pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.toObject, includeInstance),
selectedStream: jspb.Message.getFieldWithDefault(msg, 7, ""),
droppedFrameCount: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_connect.VideoFusionInfo}
 */
proto.flight_connect.VideoFusionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_connect.VideoFusionInfo;
  return proto.flight_connect.VideoFusionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_connect.VideoFusionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_connect.VideoFusionInfo}
 */
proto.flight_connect.VideoFusionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setRenderedFrameCount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setOutputChannel(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOutputBitrate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOutputFramerate(value);
      break;
    case 3:
      var value = /** @type {!proto.flight_connect.TransportType.Enum} */ (reader.readEnum());
      msg.setSelectedTransport(value);
      break;
    case 4:
      var value = new pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo;
      reader.readMessage(value,pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.deserializeBinaryFromReader);
      msg.addStreamInfo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSelectedStream(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setDroppedFrameCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_connect.VideoFusionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_connect.VideoFusionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_connect.VideoFusionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_connect.VideoFusionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRenderedFrameCount();
  if (f !== 0) {
    writer.writeSint32(
      1,
      f
    );
  }
  f = message.getOutputChannel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOutputBitrate();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getOutputFramerate();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getSelectedTransport();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStreamInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo.serializeBinaryToWriter
    );
  }
  f = message.getSelectedStream();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDroppedFrameCount();
  if (f !== 0) {
    writer.writeSint32(
      8,
      f
    );
  }
};


/**
 * optional sint32 rendered_frame_count = 1;
 * @return {number}
 */
proto.flight_connect.VideoFusionInfo.prototype.getRenderedFrameCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setRenderedFrameCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string output_channel = 2;
 * @return {string}
 */
proto.flight_connect.VideoFusionInfo.prototype.getOutputChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setOutputChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 output_bitrate = 5;
 * @return {number}
 */
proto.flight_connect.VideoFusionInfo.prototype.getOutputBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setOutputBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional uint64 output_framerate = 6;
 * @return {number}
 */
proto.flight_connect.VideoFusionInfo.prototype.getOutputFramerate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setOutputFramerate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional TransportType.Enum selected_transport = 3;
 * @return {!proto.flight_connect.TransportType.Enum}
 */
proto.flight_connect.VideoFusionInfo.prototype.getSelectedTransport = function() {
  return /** @type {!proto.flight_connect.TransportType.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.flight_connect.TransportType.Enum} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setSelectedTransport = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated VideoStreamInfo stream_info = 4;
 * @return {!Array<!proto.flight_connect.VideoStreamInfo>}
 */
proto.flight_connect.VideoFusionInfo.prototype.getStreamInfoList = function() {
  return /** @type{!Array<!proto.flight_connect.VideoStreamInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_flight_connect_video_stream_info_pb.VideoStreamInfo, 4));
};


/**
 * @param {!Array<!proto.flight_connect.VideoStreamInfo>} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
*/
proto.flight_connect.VideoFusionInfo.prototype.setStreamInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.flight_connect.VideoStreamInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.flight_connect.VideoStreamInfo}
 */
proto.flight_connect.VideoFusionInfo.prototype.addStreamInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.flight_connect.VideoStreamInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.clearStreamInfoList = function() {
  return this.setStreamInfoList([]);
};


/**
 * optional string selected_stream = 7;
 * @return {string}
 */
proto.flight_connect.VideoFusionInfo.prototype.getSelectedStream = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setSelectedStream = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional sint32 dropped_frame_count = 8;
 * @return {number}
 */
proto.flight_connect.VideoFusionInfo.prototype.getDroppedFrameCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.flight_connect.VideoFusionInfo} returns this
 */
proto.flight_connect.VideoFusionInfo.prototype.setDroppedFrameCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


goog.object.extend(exports, proto.flight_connect);
